import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuerySample } from '@store/helpers';

export const vehicleApi = createApi({
  reducerPath: 'Vehicle',
  tagTypes: ['Vehicle'],
  baseQuery: baseQuerySample,
  endpoints: (builder) => ({
    getVehicleData: builder.query({
      query: ({ page, size, sortBy = 'expirationDate', sortDir = 'desc' }) => ({
        url: `/v1/vehicles/vehicle?page=${page}&size=${size}&sortBy=${sortBy}&sortDir=${sortDir}`,
      }),
    }),
    createOrUpdateVehicleData: builder.mutation({
      query: ({ id, method, body = {} }) => ({
        url: `/v1/vehicles/vehicle/${id ? `update/${id}` : 'create'}`,
        method,
        body,
      }),
    }),
    getVehicleRegistrationTableData: builder.query({
      query: ({ id, sortBy = 'expirationDate', sortDir = 'desc' }) => ({
        url: `/v1/vehicles/registration/vehicles/${id}?sortBy=${sortBy}&sortDir=${sortDir}`,
      }),
    }),
    getVehicleRegistrationById: builder.query({
      query: ({ id }) => ({
        url: `/v1/vehicles/registration/${id}`,
      }),
    }),
    createOrUpdateVehicleRegistration: builder.mutation({
      query: ({ id, method, body = {} }) => ({
        url: `/v1/vehicles/registration/${id ? `update/${id}` : 'create'}`,
        method,
        body,
      }),
    }),
    getVehicleInspectionTableData: builder.query({
      query: ({ id, sortBy = 'expirationDate', sortDir = 'desc' }) => ({
        url: `/v1/vehicles/inspection/vehicles/${id}?sortBy=${sortBy}&sortDir=${sortDir}`,
      }),
    }),
    getVehicleInspectionById: builder.query({
      query: ({ id }) => ({
        url: `/v1/vehicles/inspection/${id}`,
      }),
    }),
    createOrUpdateVehicleInspection: builder.mutation({
      query: ({ id, method, body = {} }) => ({
        url: `/v1/vehicles/inspection/${id ? `update/${id}` : 'create'}`,
        method,
        body,
      }),
    }),
    getVehiclePermitTableData: builder.query({
      query: ({ id, sortBy = 'expiration', sortDir = 'desc' }) => ({
        url: `/v1/vehicles/permit/vehicles/${id}?sortBy=${sortBy}&sortDir=${sortDir}`,
      }),
    }),
    getVehiclePermitById: builder.query({
      query: ({ id }) => ({
        url: `/v1/vehicles/permit/${id}`,
      }),
    }),
    createOrUpdateVehiclePermit: builder.mutation({
      query: ({ id, method, body = {} }) => ({
        url: `/v1/vehicles/permit/${id ? `update/${id}` : 'create'}`,
        method,
        body,
      }),
    }),
    getVehicleServiceDatesTableData: builder.query({
      query: ({ id, sortBy = 'expirationDate', sortDir = 'desc' }) => ({
        url: `/v1/vehicles/service-dates/vehicles/${id}?sortBy=${sortBy}&sortDir=${sortDir}`,
      }),
    }),
    getVehicleServiceDatesById: builder.query({
      query: ({ id }) => ({
        url: `/v1/vehicles/service-dates/${id}`,
      }),
    }),
    createOrUpdateVehicleServiceDates: builder.mutation({
      query: ({ id, method, body = {} }) => ({
        url: `/v1/vehicles/service-dates/${id ? `update/${id}` : 'create'}`,
        method,
        body,
      }),
    }),
  }),
});

export const {
  useLazyGetVehicleDataQuery,
  useCreateOrUpdateVehicleDataMutation,
  useLazyGetVehicleRegistrationTableDataQuery,
  useLazyGetVehicleRegistrationByIdQuery,
  useCreateOrUpdateVehicleRegistrationMutation,
  useLazyGetVehicleInspectionTableDataQuery,
  useLazyGetVehicleInspectionByIdQuery,
  useCreateOrUpdateVehicleInspectionMutation,
  useLazyGetVehiclePermitTableDataQuery,
  useLazyGetVehiclePermitByIdQuery,
  useCreateOrUpdateVehiclePermitMutation,
  useLazyGetVehicleServiceDatesTableDataQuery,
  useLazyGetVehicleServiceDatesByIdQuery,
  useCreateOrUpdateVehicleServiceDatesMutation,
} = vehicleApi;
